import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DashboardPage from "../pages/dashboard/page";
import DevicesPage from "../pages/devices/page";
import CapturePage from "../pages/capture/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/devices",
    element: <DevicesPage />,
  },
  {
    path: "/capture",
    element: <CapturePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;